import style from "./serviceComponent.module.css";
import Title from "component/title/TitleComponent";
import { Swiper, SwiperSlide, useSwiper } from "swiper/react";

import bg from "assets/germany/services/bg.png";

import service1 from "assets/germany/services/1.png";
import service2 from "assets/germany/services/2.png";
import service3 from "assets/germany/services/3.png";
import service4 from "assets/germany/services/4.png";
import service5 from "assets/germany/services/5.png";

import { createRef } from "react";

const Services = (props) => {
  const imgs = [service1, service2, service3, service4, service5];

  return (
    <div
      className={style.container}
      style={{
        backgroundImage: `url(${bg})`,
      }}
    >
      <div className={style.all_img_box}>
        <div className={style.img_box}>
          <img src={service1} alt="" />
        </div>
        <div className={style.img_box}>
          <img src={service2} alt="" />
        </div>
        <div className={style.img_box}>
          <Title
            className={style.title_box}
            title="Exklusiver"
            title2="Service"
            mtX="0.83vw"
            subtitle="专属服务"
            aline="left"
          />
        </div>
        <div className={style.img_box}>
          <img src={service3} alt="" />
        </div>
        <div className={style.img_box}>
          <img src={service4} alt="" />
        </div>
        <div className={style.img_box}>
          <img src={service5} alt="" />
        </div>
      </div>
    </div>
  );
};

export default Services;
